import React from 'react';
import { useSelector } from 'react-redux';
import FiltersUI from '@stencil/dstories/src/components/CityCountryPage/Filters/filters-ui';
import {
  onwardMaxPriceSelector,
  onwardMinPriceSelector,
  onwardDurationSelector,
  cityCountryFamousForSelector,
  cityCountryShowCountriesSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';

const SeoCityCountryLeft = ({
  filterSettings,
  updateFilter,
  isFilterApplied,
  isRoundTrip,
  handleResetIndividualFilter,
  handleResetFilters
}) => {
  const onwardMaxPrice = useSelector(onwardMaxPriceSelector);
  const onwardMinPrice = useSelector(onwardMinPriceSelector);
  const onwardDuration = useSelector(onwardDurationSelector);
  const famousFor = useSelector(cityCountryFamousForSelector);
  const showCountries = useSelector(cityCountryShowCountriesSelector);

  return (
    <FiltersUI
      filterSettings={filterSettings}
      updateFilter={updateFilter}
      isRoundTrip={isRoundTrip}
      isFilterApplied={isFilterApplied}
      onwardMaxPrice={onwardMaxPrice}
      onwardMinPrice={onwardMinPrice}
      onwardDuration={onwardDuration}
      isLoading={onwardMaxPrice ? false : true}
      famousFor={famousFor}
      showCountries={showCountries}
      handleResetIndividualFilter={handleResetIndividualFilter}
      handleResetFilters={handleResetFilters}
    />
  );
};
export default SeoCityCountryLeft;
